import { MoveRight } from 'lucide-react'
import { useNavigate } from 'react-router'
import Card from '../../../../components/common/Card'
import DefaultTable from '../../../../components/tables/DefaultTable/DefaultTable'
import { useProduct } from '../../../../context/ProductContext'

const Business = () => {
    const navigate = useNavigate()
    const { detail } = useProduct()
    if (!detail) return null

    const rows = detail.business.map(item => ({
        ...item,
        path: (
            <div className='space-y-1'>
                <p className='font-bold'>{item.company}</p>
                <div className='flex items-center gap-2 text-sm' style={{ color: item.color }}>
                    <span>{item.pipeline}</span>
                    <MoveRight className='h-4 w-4' />
                    <span>{item.step}</span>
                </div>
            </div>
        )
    }))

    return (
        <Card>
            <h4 className='mb-4 font-bold'>Negócios vinculados</h4>
            <DefaultTable
                columns={[
                    { key: 'id', label: '#' },
                    { key: 'path', label: 'Negócio' },
                    { key: 'value', label: 'Valor' },
                    { key: 'dateConclude', label: 'Conclusão' }
                ]}
                rows={rows}
                rowsPerPage={20}
                handleClick={row => navigate(`/negocio/${row.id}`)}
            />
        </Card>
    )
}

export default Business
